export const getImport = ({ productImport }) => productImport
